import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Compass, Check, CaretDown, CaretUp, ArrowRight, Trophy } from '@phosphor-icons/react';
import axios from 'axios';
import { API_URL } from '../config/api';

export const ExploreStrip = () => {
  const [data, setData] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API_URL}/api/explore/progress`, { withCredentials: true })
      .then(res => setData(res.data))
      .catch(() => {});
  }, []);

  if (!data || data.completed === data.total) return null;

  const pct = Math.round((data.completed / data.total) * 100);
  const remaining = data.items.filter(i => !i.completed);

  const handleClick = async (item) => {
    if (!item.completed) {
      await axios.post(`${API_URL}/api/explore/complete`, { item_id: item.id }, { withCredentials: true }).catch(() => {});
      setData(prev => ({
        ...prev,
        items: prev.items.map(i => i.id === item.id ? { ...i, completed: true } : i),
        completed: prev.completed + 1,
      }));
    }
    navigate(item.path);
  };

  return (
    <div className="max-w-7xl mx-auto px-3 sm:px-6 pt-3" data-testid="explore-strip">
      <div className="rounded-lg border border-emerald-200 dark:border-emerald-800 bg-emerald-50/50 dark:bg-emerald-950/20 overflow-hidden">
        <button
          onClick={() => setExpanded(!expanded)}
          className="w-full flex items-center justify-between px-4 py-2.5 hover:bg-emerald-100/50 dark:hover:bg-emerald-900/20 transition-colors"
          data-testid="explore-strip-toggle"
        >
          <div className="flex items-center gap-2.5">
            <Compass size={16} className="text-emerald-600 dark:text-emerald-400" />
            <span className="text-sm font-medium text-emerald-800 dark:text-emerald-200">
              Explore TurfPulse
            </span>
            <div className="hidden sm:flex items-center gap-2 ml-2">
              <div className="w-24 h-1.5 rounded-full bg-emerald-200 dark:bg-emerald-800 overflow-hidden">
                <div className="h-full rounded-full bg-emerald-500 transition-all" style={{ width: `${pct}%` }} />
              </div>
              <span className="text-xs text-emerald-600 dark:text-emerald-400 font-semibold">{data.completed}/{data.total}</span>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="sm:hidden text-xs text-emerald-600 font-semibold">{data.completed}/{data.total}</span>
            {expanded ? <CaretUp size={14} className="text-emerald-600" /> : <CaretDown size={14} className="text-emerald-600" />}
          </div>
        </button>

        {expanded && (
          <div className="border-t border-emerald-200 dark:border-emerald-800 divide-y divide-emerald-100 dark:divide-emerald-900">
            {remaining.slice(0, 4).map(item => (
              <button
                key={item.id}
                onClick={() => handleClick(item)}
                className="w-full flex items-center gap-3 px-4 py-2 text-left hover:bg-emerald-100/50 dark:hover:bg-emerald-900/20 transition-colors"
              >
                <div className="w-5 h-5 rounded-full border-2 border-emerald-300 dark:border-emerald-700 shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground">{item.label}</p>
                  <p className="text-xs text-muted-foreground">{item.desc}</p>
                </div>
                <ArrowRight size={14} className="text-emerald-500 shrink-0" />
              </button>
            ))}
            {remaining.length > 4 && (
              <div className="px-4 py-2 text-center">
                <button onClick={() => navigate('/')} className="text-xs text-emerald-600 hover:text-emerald-700 font-medium">
                  View all {remaining.length} remaining →
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
